<div [ngClass]="{ superior: superior, inferior: inferior }" class="enable tekinput">
  <div *ngIf="isTeacher && !isTry" class="tooltip tooltip--visible" [ngClass]="{ 'tooltip--size': superior || inferior }">
    <span>{{ correctValue }}</span>
  </div>
  <ng-container [ngSwitch]="tekInputType">
    <mat-form-field
      class="tekinput-select activity-input custom-select"
      *ngSwitchCase="'dropdown'"
      [ngClass]="{
        inactive: disabled && !validated,
        superior: superior,
        inferior: inferior,
        enable: !disabled && !validated,
        correct: (isCorrect && validated && isSelfCorrecting) || (isCorrect && isTeacher),
        wrong: (!isCorrect && validated && isSelfCorrecting) || (!isCorrect && isTeacher),
        'text-negro': !isSelfCorrecting
      }">
      <mat-select [disabled]="disabled" [(ngModel)]="value">
        <mat-option *ngFor="let option of options | SplitOptions" [value]="option">{{ option }}</mat-option>
      </mat-select>
    </mat-form-field>
    <input
      *ngSwitchDefault
      name="{{ controlName }}"
      #answer
      type="text"
      (change)="checkValue(answer.value)"
      maxlength="50"
      [(ngModel)]="value"
      (ngModelChange)="value = normalizeInput($event)"
      [disabled]="disabled"
      [ngClass]="{
        inactive: disabled && !validated,
        superior: superior,
        inferior: inferior,
        enable: !disabled && !validated,
        correct: (isCorrect && validated && isSelfCorrecting) || (isCorrect && isTeacher),
        wrong: (!isCorrect && validated && isSelfCorrecting) || (!isCorrect && isTeacher),
        'text-negro': !isSelfCorrecting
      }"
      class="activity-input inputAnswer"
      [ngStyle]="{ width: value.length + 1 + 'ch' }"
      autocomplete="off" />
  </ng-container>
</div>
